"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FeatureValueTypes_1 = require("../../continueInDealership/enum/FeatureValueTypes");
var features_1 = require("../../../../common/constants/features");
var ImageType_1 = require("../../../../common/enum/ImageType");
var core_1 = require("@material-ui/core");
exports.useImageUrl = function (carConfiguration) {
    var isFromAltSpc = core_1.useTheme().checkoutLite.isFromAltSpc;
    var _a = react_1.useState(''), carImageUrl = _a[0], setCarImageUrl = _a[1];
    var _b = react_1.useState(true), isBackgroundDefault = _b[0], setIsBackgroundDefault = _b[1];
    var _c = react_1.useState(true), isRoofDefault = _c[0], setIsRoofDefault = _c[1];
    react_1.useEffect(function () {
        if (isFromAltSpc) {
            altSpcImageHandler();
        }
        else {
            defaultImageHandler();
        }
    }, [carConfiguration]);
    var altSpcImageHandler = react_1.useCallback(function () {
        var _a, _b, _c, _d, _e;
        var carImage = (_b = (_a = carConfiguration) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.find(function (image) { return image.type === FeatureValueTypes_1.FeatureValueTypes.EXTERIOR_360; }).url;
        if (carImage) {
            var carImageUrl_1 = new URL(carImage);
            //@TODO: We will need to request oemcode for optionalFeatures in order to not rely in image params
            var imgUrlParams = new URLSearchParams(carImageUrl_1.search);
            var bgValue = imgUrlParams.get(features_1.FEATURES.BACKGROUND_URL_PARAMS);
            var roofValue = imgUrlParams.get(features_1.FEATURES.ROOF_URL_PARAMS);
            setIsRoofDefault(roofValue === FeatureValueTypes_1.FeatureValueTypes.DEFAULT);
            setIsBackgroundDefault(bgValue === FeatureValueTypes_1.FeatureValueTypes.DEFAULT);
            setCarImageUrl(carImage);
        }
        else {
            setCarImageUrl((_e = (_d = (_c = carConfiguration) === null || _c === void 0 ? void 0 : _c.exteriorColour) === null || _d === void 0 ? void 0 : _d.images.find(function (image) { return image.type === ImageType_1.ImageType.FRONT; })) === null || _e === void 0 ? void 0 : _e.url);
        }
    }, []);
    var defaultImageHandler = react_1.useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var imageSrc = (_c = (_b = (_a = carConfiguration) === null || _a === void 0 ? void 0 : _a.exteriorColour) === null || _b === void 0 ? void 0 : _b.images.find(function (image) { return image.type === ImageType_1.ImageType.FRONT; })) === null || _c === void 0 ? void 0 : _c.url;
        if (!imageSrc) {
            imageSrc = (_e = (_d = carConfiguration) === null || _d === void 0 ? void 0 : _d.images.find(function (image) { return image.type === ImageType_1.ImageType.FRONT; })) === null || _e === void 0 ? void 0 : _e.url;
        }
        if (!imageSrc) {
            imageSrc = (_g = (_f = carConfiguration) === null || _f === void 0 ? void 0 : _f.nameplate.images) === null || _g === void 0 ? void 0 : _g.url;
        }
        setCarImageUrl(imageSrc);
    }, []);
    return { carImageUrl: carImageUrl, isBackgroundDefault: isBackgroundDefault, isRoofDefault: isRoofDefault };
};
